<template>
    <v-flex>
        <div v-if="resultsLayout && test_history && not_full_answer" class="red-text">{{$t("Выбраны не все варианты ответов")}}</div>
        <v-flex v-for="(item,i) in variants" :key="i" class="question__wrap">
            <checkbox
                :id="'check'+question_number+i"
                :key="i"
                :checked = 'item.selected'
                :name="'name'+question_number"
                :class="{'test__image-checkbox': item.image,
                         'test__image-checkbox--checked': item.image && item.selected,
                         'correct': item.selected && resultsLayout && (if_correct || if_partially_correct),
                         'wrong': item.selected && resultsLayout && if_incorrect(item)}"
                :disabled="resultsLayout"
                @click="$emit('change', {$event, variant_number:i})"
            >
                <v-flex v-if="item.image">
                    <v-flex v-html="question_image(question_number)[i]" />
                    <!-- <v-tooltip v-if="resultsLayout && item.tooltip" top class="question__tooltip-image">
                        <svg v-svg
                             slot="activator"
                             symbol="tooltip"
                             size="20"
                             class="question__tooltip"
                             role="presentation"
                        />
                        <span>{{ item.tooltip }}</span>
                    </v-tooltip> -->
                </v-flex>
                <v-flex v-else> {{ item.text }}
                    <v-tooltip v-if="resultsLayout && item.tooltip" top>
                        <svg v-svg
                             slot="activator"
                             symbol="tooltip"
                             size="20"
                             class="question__tooltip"
                             role="presentation"
                        />
                        <span>{{ item.tooltip }}</span>
                    </v-tooltip>
                </v-flex>
            </checkbox>
            <v-flex v-if="item.selected && resultsLayout && (if_correct || if_partially_correct)"
                    class="question__check-wrap"
            >
                <svg v-svg
                     symbol="ok"
                     class="question__check"
                     role="presentation"
                />
            </v-flex>
            <v-flex v-if="item.selected && resultsLayout && if_incorrect(item)"
                    class="question__check-wrap question__check-wrap-wrong"
            >
                <svg v-svg
                     symbol="error"
                     class="question__check"
                     role="presentation"
                />
            </v-flex>
        </v-flex>
    </v-flex>
</template>

<script>
import checkbox from '@/components/ui/inputs/base/checkbox';
import {mapGetters} from 'vuex';
export default {
  components: {
    checkbox,
  },
  props: {
    variants: {
      type   : Array,
      default: ()=> [],
    },
    name: {
      type: String,
    },
  },
  data() {
    return {

    };
  },
  computed: {
    ...mapGetters('testing/questions', [
      'question_image',
      'question_number',
      'questions',
      'stats',
      'test_history',
    ]),
    ...mapGetters('testing', [
      'resultsLayout',
    ]),
    if_correct() {
      let question = this.test_history.find((item)=>{
        return item.question_id==this.questions[this.question_number].id;
      });
      if (question) {
        return question.success_answer;
      }
    },
    not_full_answer() {
      if (this.test_history) {
        let question = this.test_history.find((item)=>{
          return item.question_id==this.questions[this.question_number].id;
        });
        if (question && !question.success_answer && question.incorrect_answers.length==0) {
          return true;
        } else return false;
      }
    },

  },
  methods: {
    if_incorrect(variant) {
      let question = this.test_history.find((item)=>{
        return item.question_id==this.questions[this.question_number].id;
      });
      if (question && !question.success_answer && question.incorrect_answers.includes(String(variant.id))) {
        return true;
      } else return false;
    },
    if_partially_correct(variant) {
      let question = this.test_history.find((item)=>{
        return item.question_id==this.questions[this.question_number].id;
      });
      if (question && !question.success_answer && question.incorrect_answers.length==0) {
        return true;
      } else return false;
    },

  },
};
</script>

